
import { useState } from "react";
import { Filter, X } from "lucide-react";
import { Team } from "../types";
import { Button } from "@/components/ui/button";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface TeamFilterProps {
  teams: Team[];
  onFilterChange: (selectedTeamId: string | null) => void;
}

export const TeamFilter = ({ teams, onFilterChange }: TeamFilterProps) => {
  const [selectedTeam, setSelectedTeam] = useState<string | null>(null);

  const handleTeamSelect = (value: string) => {
    console.log("Team selected:", value);
    setSelectedTeam(value);
    onFilterChange(value);
  };

  const clearFilter = () => {
    console.log("Clearing filter");
    setSelectedTeam(null);
    onFilterChange(null);
  };

  return (
    <div className="flex gap-2 w-full">
      <div className="flex-1 relative">
        <Select 
          value={selectedTeam || ""} 
          onValueChange={handleTeamSelect}
        >
          <SelectTrigger className="w-full bg-background">
            <div className="flex items-center gap-2">
              <Filter className="h-4 w-4 text-muted-foreground" />
              <SelectValue placeholder="Filter by team" />
            </div>
          </SelectTrigger>
          <SelectContent 
            className="bg-background max-h-[40vh] overflow-y-auto w-full z-50"
            position="popper"
            side="bottom"
            align="start"
            sideOffset={8}
          >
            {teams.map((team) => (
              <SelectItem 
                key={team.id} 
                value={team.id}
                className="cursor-pointer"
              >
                {team.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={clearFilter}
        className="flex-shrink-0"
        disabled={!selectedTeam}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
